import { PublicKey } from "@solana/web3.js";
export const PROGRAM_ID = new PublicKey("noEmmgLmQdk6DLiPV8CSwQv3qQDyGEhz9m5A4zhtByv");
//# sourceMappingURL=constants.js.map